<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Educational Background</h1>
        <v-alert type="warning" v-if="selectedEmp.remarks != null">{{
          selectedEmp.remarks
        }}</v-alert>
        <emp-image :empCode="selectedEmp.code"></emp-image>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <emp-lookup
              :class-padding="classPadding"
              v-model="selectedEmp"
              label="Employee Code"
              title="Employee"
              :code-value="true"
              :required="true"
            ></emp-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
            <v-text-field
              label="Name"
              :value="selectedEmp.desc"
              :class="classPadding"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <school-lookup
              :class-padding="classPadding"
              v-model="selectedSchool"
              label="School"
              title="School"
            ></school-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-textarea
              rows="3"
              label="Other School"
              v-model="model.otherSchool"
              :class="classPadding"
            ></v-textarea>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-textarea
              rows="3"
              v-model="model.address"
              :class="classPadding"
              label="Address"
              autocomplete="off"
            ></v-textarea>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <country-lookup
              :class-padding="classPadding"
              v-model="selectedCountry"
              label="School Country"
              title="Country"
            ></country-lookup>
          </v-col>
          
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-select
              v-model="model.level"
              :class="classPadding"
              label="Level"
              :items="levelItems"
              item-text="text"
              item-value="value"
              autocomplete="off"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <educ-attain-lookup
              :class-padding="classPadding"
              v-model="selectedAttainment"
              label="Educ. Attainment"
              title="Educ. Attainment"
              :class="classPadding"
              :required="true"
            ></educ-attain-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <edu-est-lookup
              :class-padding="classPadding"
              v-model="selectedEst"
              label="Educ. Establishment"
              title="Educ. Establishment"
              :class="classPadding"
            ></edu-est-lookup>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <course-lookup
              :class-padding="classPadding"
              v-model="selectedCourse"
              label="Course/Degree"
              title="Course/Degree"
              :class="classPadding"
            ></course-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <major-lookup
              :class-padding="classPadding"
              v-model="selectedMajor"
              label="Major"
              title="Major"
              :class="classPadding"
            ></major-lookup>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Honors"
              :class="classPadding"
              v-model="model.honor"
              autocomplete="off"
            ></v-text-field>
          </v-col>
           <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Final Grade"
              :class="classPadding"
              v-model="model.finalGrade"
              autocomplete="off"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="School Year From"
              type="number"
              :class="classPadding"
              v-model="model.yearFr"
              autocomplete="off"
            >
              <template slot="append">
                <span class="required">*</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="School Year To"
              type="number"
              :class="classPadding"
              v-model="model.yearTo"
              autocomplete="off"
            >
              <template slot="append">
                <span class="required">*</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <!-- <v-text-field autocomplete="off" label="Date" type="date" :class="classPadding"></v-text-field> -->
            <custom-datepicker
              :class-padding="classPadding"
              label="Start Date"
              v-model="model.sDate"
            ></custom-datepicker>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <!-- <v-text-field autocomplete="off" label="Date" type="date" :class="classPadding"></v-text-field> -->
            <custom-datepicker
              :class-padding="classPadding"
              label="End Date"
              v-model="model.eDate"
            ></custom-datepicker>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="License Number"
              :class="classPadding"
              v-model="model.licenseNumber"
              autocomplete="off"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Remarks"
              :class="classPadding"
              v-model="model.remarks"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-file-input
              label="Attachment"
              ref="webLogoReports"
              :class="classPadding"
              v-model="attachment"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Add</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <list :emp-code="selectedEmp.code" :key="componentKey">
              <template slot="actions" slot-scope="{ item }">
                <v-btn
                  @click.stop="edit(item)"
                  text
                  icon
                  v-if="userAccess.edit >= 1"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  @click.stop="deleteItem(item)"
                  text
                  icon
                  v-if="userAccess.delete >= 1"
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <template slot="attachment" slot-scope="{ item }">
                <v-btn @click.stop="viewAttachment(item)" text outlined
                  >View</v-btn
                >
              </template>
            </list>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-dialog v-model="editDialog" width="900" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <br />
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <school-lookup
                :class-padding="classPadding"
                v-model="editSelectedSchool"
                label="School"
                title="School"
              ></school-lookup>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-textarea
                rows="3"
                label="Other School"
                v-model="editModel.otherSchool"
                :class="classPadding"
              ></v-textarea>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-textarea
                rows="3"
                v-model="editModel.address"
                :class="classPadding"
                label="Address"
                autocomplete="off"
              ></v-textarea>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <country-lookup
                :class-padding="classPadding"
                v-model="editSelectedCountry"
                label="School Country"
                title="Country"
              ></country-lookup>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-select
                v-model="editModel.level"
                :class="classPadding"
                label="Level"
                :items="levelItems"
                item-text="text"
                item-value="value"
                autocomplete="off"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <educ-attain-lookup
                :class-padding="classPadding"
                v-model="editSelectedAttainment"
                label="Educ. Attainment"
                title="Educ. Attainment"
                :class="classPadding"
                :required="true"
              ></educ-attain-lookup>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <edu-est-lookup
                :class-padding="classPadding"
                v-model="editSelectedEst"
                label="Educ. Establishment"
                title="Educ. Establishment"
                :class="classPadding"
              ></edu-est-lookup>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <course-lookup
                :class-padding="classPadding"
                v-model="editSelectedCourse"
                label="Course/Degree"
                title="Course/Degree"
                :class="classPadding"
              ></course-lookup>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <major-lookup
                :class-padding="classPadding"
                v-model="editSelectedMajor"
                label="Major"
                title="Major"
                :class="classPadding"
              ></major-lookup>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field
                label="Honors"
                :class="classPadding"
                v-model="editModel.honor"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field
                label="Final Grade"
                :class="classPadding"
                v-model="editModel.finalGrade"
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                label="School Year From"
                type="number"
                :class="classPadding"
                v-model="editModel.yearFr"
                autocomplete="off"
              >
                <template slot="append">
                  <span class="required">*</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                label="School Year To"
                type="number"
                :class="classPadding"
                v-model="editModel.yearTo"
                autocomplete="off"
              >
                <template slot="append">
                  <span class="required">*</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <!-- <v-text-field autocomplete="off" label="Date" type="date" :class="classPadding"></v-text-field> -->
              <custom-datepicker
                :class-padding="classPadding"
                label="Start Date"
                v-model="editModel.sDate"
              ></custom-datepicker>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <!-- <v-text-field autocomplete="off" label="Date" type="date" :class="classPadding"></v-text-field> -->
              <custom-datepicker
                :class-padding="classPadding"
                label="End Date"
                v-model="editModel.eDate"
              ></custom-datepicker>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                label="License Number"
                :class="classPadding"
                v-model="editModel.licenseNumber"
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field
                label="Remarks"
                :class="classPadding"
                v-model="editModel.remarks"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-file-input
                label="Attachment"
                :class="classPadding"
                v-model="attachment"
                autocomplete="off"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="editDialog = false"
            >Close</v-btn
          >
          <v-btn
            text
            color="success"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EmpLookup from "../../employee-masterfile/personal-info/Lookup";
import List from "./List";
import { viewFileWithLocation } from "../../../../helpers/utility";
import SchoolLookup from "../../../setup/employment-other-info/education/school/Lookup";
import EducAttainLookup from "../../../setup/employment-other-info/education/educ-attainment/Lookup";
import CourseLookup from "../../../setup/employment-other-info/education/course/Lookup";
import MajorLookup from "../../../setup/employment-other-info/education/major/Lookup";
import selectEmpMixin from "../../employee-masterfile/personal-info/mixins/selectEmpMixin";
import EmpImage from "../../employee-masterfile/personal-info/Image";
import userAccessMixin from "../../../../mixins/userAccessMixin";
import CountryLookup from "../../../others/CountryLookup.vue"
import EduEstLookup from "../../../setup/employment-other-info/education/educ-establishment/Lookup.vue"
import CustomDatepicker from "../../../../components/CustomDatepicker";
const API_ENDPOINT = "/api/educBackground";
const FOLDER_NAME = "educBackground";
export default {
  metaInfo: {
    title: "Educational Background",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [selectEmpMixin, userAccessMixin],
  data: () => ({
    model: {
      date: new Date().toISOString()
    },
    classPadding: "my-0 py-0",
    selectedEmp: {},
    dateModel: null,
    isSaving: false,
    componentKey: 0,
    editModel: {},
    editDialog: false,
    attachment: null,
    attachmentDialog: false,
    attachmentImage: null,
    isUpdating: false,
    selectedSchool: {},
    selectedMajor: {},
    selectedAttainment: {},
    selectedCourse: {},
    selectedCountry: {},
    selectedEst: {},
    editSelectedSchool: {},
    editSelectedMajor: {},
    editSelectedAttainment: {},
    editSelectedCourse: {},
    editSelectedCountry: {},
    editSelectedEst: {},
    levelItems: [
      {
        text: "Elementary",
        value: "Elementary"
      },
      {
        text: "High School",
        value: "High School"
      },
      {
        text: "College",
        value: "College"
      },
      {
        text: "Post Graduate",
        value: "Post Graduate"
      },
      {
        text: "Others",
        value: "Others"
      },
      {
        text: "Honors/Awards",
        value: "Honors/Awards"
      }
    ]
  }),
  components: {
    EmpLookup,
    List,
    SchoolLookup,
    EducAttainLookup,
    CourseLookup,
    MajorLookup,
    EmpImage,
    CountryLookup,
    EduEstLookup,
    CustomDatepicker
  },
  computed: {
    attachmentUrl() {
      if (
        this.attachmentImage == null ||
        typeof this.attachmentImage == "undefined" ||
        this.attachmentImage == ""
      )
        return "";
      else return `data:image/jpeg;base64, ${this.attachmentImage}`;
    }
  },
  methods: {
    save() {
      this.isSaving = true;
      this.model.empCode = this.selectedEmp.code;
      this.model.schoolCode = this.selectedSchool.code;
      this.model.eduAttCode = this.selectedAttainment.code;
      this.model.majorCode = this.selectedMajor.code;
      this.model.courseCode = this.selectedCourse.code;
      this.model.eduEstCode = this.selectedEst.code;
      this.model.country = this.selectedCountry.code;

      var formData = new FormData();
      var data = Object.assign({}, this.model);
      formData.append("json", JSON.stringify(data));
      formData.append("attachment", this.attachment);

      // this.$axios
      //   .post(`${API_ENDPOINT}`, this.model)
      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.editDialog = true;
      item.level = item.educLevel;
      this.editModel = Object.assign({}, item);

      this.editSelectedSchool = {
        code: item.schoolCode,
        desc: item.schoolDesc
      };
      this.editSelectedMajor = {
        code: item.majorCode,
        desc: item.majorDesc
      };
      this.editSelectedAttainment = {
        code: item.eduAttCode,
        desc: item.eduAttDesc
      };
      this.editSelectedCourse = {
        code: item.courseCode,
        desc: item.courseDesc
      };

      this.editSelectedEst = {
        code: item.eduEstCode,
        desc: item.eduEstDesc
      };

      this.editSelectedCountry = {
        code: item.country,
        desc: item.countryDesc
      };
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.empEduId}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.model = {};
      this.forceRerender();
      this.editDialog = false;
      this.selectedSchool = {};
      this.selectedMajor = {};
      this.selectedAttainment = {};
      this.selectedCourse = {};
      this.attachment = null;
      this.selectedCountry = {};
      this.selectedEst = {};
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.editModel.empCode = this.selectedEmp.code;
      this.editModel.schoolCode = this.editSelectedSchool.code;
      this.editModel.eduAttCode = this.editSelectedAttainment.code;
      this.editModel.majorCode = this.editSelectedMajor.code;
      this.editModel.courseCode = this.editSelectedCourse.code;
      this.editModel.eduEstCode = this.editSelectedEst.code;
      this.editModel.country = this.editSelectedCountry.code;

      var formData = new FormData();
      var data = Object.assign({}, this.editModel);
      formData.append("json", JSON.stringify(data));
      formData.append("attachment", this.attachment);

      // this.$axios
      //   .post(`${API_ENDPOINT}`, this.model)
      this.$axios({
        method: "PUT",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    viewAttachment(item) {
      viewFileWithLocation(
        item.location
      );
    }
  },
  watch: {
    selectedEmp() {
      this.forceRerender();
    }
  },
  created() {
    this.getUserAccessRights("EMFOINEDUC");
  }
};
</script>